import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHoldCall = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.2271 1.81818H6.59073C7.69869 1.81818 8.63619 2.75568 8.63619 3.86363V16.1364C8.63619 17.2869 7.69869 18.1818 6.59073 18.1818H5.2271C4.07653 18.1818 3.18164 17.2869 3.18164 16.1364V3.86363C3.18164 2.75568 4.07653 1.81818 5.2271 1.81818ZM13.4089 1.81818H14.7725C15.8805 1.81818 16.818 2.75568 16.818 3.86363V16.1364C16.818 17.2869 15.8805 18.1818 14.7725 18.1818H13.4089C12.2583 18.1818 11.3635 17.2869 11.3635 16.1364V3.86363C11.3635 2.75568 12.2583 1.81818 13.4089 1.81818Z",
		fill: "currentColor"
	})
});
export default SvgHoldCall;
